var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sm:hidden fixed w-full left-0 bottom-0 bg-gray-900 border-t-3 border-red-200 shadow"},[_c('Pagination',{attrs:{"search":_vm.search,"type":_vm.type},on:{"pn-updated":_vm.reloadVideos}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }